import React from 'react';
import { Box, Button, Typography, Paper } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
    Title: {
        fontFamily: "UniviaPro-Bold",
        fontSize: '13px',
        letterSpacing: '0.13px ',
        lineHeight: '16.3px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        color: '#4f5064'
    },
    Close: {
        fontFamily: "UniviaPro",
        fontSize: '10px',
        letterSpacing: '0.4px ',
        lineHeight: '12.5px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
    }
}))

function Index({ onClose, popupState, children, }) {
    const translate = useTranslate();
    const classes = useStyles();
    return (
        <CustomPopoverArrow
            zIndex={1500}
            popupState={popupState}
            placement='right-start'
        >
            <Paper style={{ width: 170 }}>
                <Box p={2} pb={0}>
                    <Typography className={classes.Title} > {translate("resources.messages.sendMessageTo")}</Typography>
                </Box>
                {children}
                <Box display='flex' justifyContent='flex-end'>
                    <Button
                        color='primary'
                        type='button'
                        style={{ marginRight: '1rem', marginBottom: '10px' }}
                        onClick={onClose}
                    ><Typography className={classes.Close} >{translate('pos.common.close')}</Typography></Button>
                </Box>
            </Paper>
        </CustomPopoverArrow>
    )
}

Index.propTypes = {
    popupState: PropTypes.object,
    onClose: PropTypes.func.isRequired
}

export default Index;
